
import React from 'react'
import icon from './svgs/ProgressColored.svg'
import { BaseIcon } from './_base'

export const ProgressColoredIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
